import {
  ViveApiBaseService,
  ViveApiRequestOptions
} from './vive-api-base.service';
import {
  ApConfigDto,
  ApConfigsFindAllRequestDto,
  ApConfigsFindAllResponseDto,
  ApConfigsUpdateOneRequestDto
} from './vive-api-models';

class ApConfigsService extends ViveApiBaseService {
  public async findAll(params: {
    options?: ViveApiRequestOptions;
    queryParams?: Omit<ApConfigsFindAllRequestDto, 'includeAssociations'>;
  }): Promise<ApConfigsFindAllResponseDto> {
    const { options, queryParams } = params;
    return await this.sendGet<ApConfigsFindAllResponseDto>({
      apiEndpoint: 'ap-configs',
      options,
      queryParams
    });
  }

  public async findAllForClient(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
    queryParams?: Omit<ApConfigsFindAllRequestDto, 'includeAssociations'>;
  }): Promise<ApConfigsFindAllResponseDto> {
    const { options, pathParams, queryParams } = params;
    return await this.sendGet<ApConfigsFindAllResponseDto>({
      apiEndpoint: 'ap-configs/company/:companyId',
      options,
      pathParams,
      queryParams
    });
  }

  public async findById(params: {
    options?: ViveApiRequestOptions;
    pathParams: { apConfigId: number };
  }): Promise<ApConfigDto> {
    const { options, pathParams } = params;
    return await this.sendGet<ApConfigDto>({
      apiEndpoint: `ap-configs/:apConfigId`,
      options,
      pathParams
    });
  }

  public async updateById(params: {
    options?: ViveApiRequestOptions;
    pathParams: { apConfigId: number };
    data: ApConfigsUpdateOneRequestDto;
  }): Promise<ApConfigDto> {
    const { options, pathParams, data } = params;
    return await this.sendPatch<ApConfigDto>({
      apiEndpoint: `ap-configs/:apConfigId`,
      options,
      pathParams,
      data
    });
  }

  public async syncAllVendors(params: {
    options?: ViveApiRequestOptions;
    pathParams: { apConfigId: number };
  }): Promise<void> {
    const { options, pathParams } = params;
    await this.sendPost<void>({
      apiEndpoint: 'ap-configs/:apConfigId/sync-all-vendors',
      options,
      pathParams
    });
  }
}

export const apConfigsService = new ApConfigsService();
